export class NoWebCallFnError extends Error {
  name = 'NO_WEB_CALL_FN_ERROR'
}
